import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import styles from './MetricValueLink.module.scss';

export interface MetricValueLinkProps {
    /** Page this metric belongs to. */
    to: string;
    children: ReactNode;
    'aria-label'?: string;
}

/**
 * A metric value that links to the page it came from.
 *
 * Owns its own appearance instead of inheriting the global anchor colour: body
 * text with an underline, turning blue only on hover. A whole column of values
 * rendered in link blue reads as noise, and the underline is what tells the
 * reader the value is clickable.
 *
 * Wrap the value itself, never a subtree containing an inline-block: text
 * decorations do not propagate into atomic inline-level descendants, so the
 * underline would silently disappear.
 */
export default function MetricValueLink(props: MetricValueLinkProps) {
    const { to, children } = props;

    return (
        <Link to={to} className={styles.metricLink} aria-label={props['aria-label']}>
            {children}
        </Link>
    );
}
